type Props = {
  value: string;
  onChange: (value: string) => void;
};

export default function TextInputStep({ value, onChange }: Props) {
  return (
    <div className="flex flex-col gap-sm">
      <p className="text-heading-xxs text-main">テキスト入力</p>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="面談情報などの文字起こしやメモを入力してください"
        className="h-[209px] w-full resize-none rounded-sm border border-solid border-border px-md py-sm text-body-sm text-main placeholder:text-placeholder! focus:border-primary focus:outline-2 focus:-outline-offset-2 focus:outline-primary"
      />
    </div>
  );
}
